/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return BillingPlanDefinition.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanDefinition>): BillingPlanDefinition {
        let obj = Object.assign(new BillingPlanDefinition(), model);
        BillingPlanDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanDefinition>): BillingPlanDefinition {
        if (!model) return null;
        return BillingPlanDefinition.newInstance(<BillingPlanDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanDefinition) {
        if (!obj) return;

        models.BillingPlanDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingPlanDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owner of the billing plan
     */
    owner: string;

    /**
     * Name of the billing plan
     */
    name: string;

    /**
     * Description of the billing plan
     */
    description: string;

    /**
     * States if the billing plan is active or not
     */
    is_active: boolean;

    /**
     * States if the plan is a template or not
     */
    is_template: boolean;

    /**
     * Notes for the billing plan
     */
    notes: string;

    /**
     * List of attachment IDs
     */
    attachment_ids: Array<string>;

    /**
     * States if the billing plan is for raw list cost adjusted billing plan or not
     */
    raw_list_cost_adjusted_billing_plan: boolean;

    /**
     * Created by
     */
    created_by: string;

    /**
     * Updated by
     */
    updated_by: string;

}
